var map = {
	"./Color Gamut & Color TemperatureCustom 1.png": "./src/assets/img/Color Gamut & Color TemperatureCustom 1.png",
	"./Color Gamut & Color TemperatureLow Blue Light.png": "./src/assets/img/Color Gamut & Color TemperatureLow Blue Light.png",
	"./Color Gamut & Color Temperaturebluish(9300k).png": "./src/assets/img/Color Gamut & Color Temperaturebluish(9300k).png",
	"./Color Gamut & Color Temperaturebt.709.png": "./src/assets/img/Color Gamut & Color Temperaturebt.709.png",
	"./Color Gamut & Color Temperaturecustom1.png": "./src/assets/img/Color Gamut & Color Temperaturecustom1.png",
	"./Color Gamut & Color Temperaturedci-p3.png": "./src/assets/img/Color Gamut & Color Temperaturedci-p3.png",
	"./Color Gamut & Color Temperatureneutral.png": "./src/assets/img/Color Gamut & Color Temperatureneutral.png",
	"./Color Gamut & Color Temperaturereddish.png": "./src/assets/img/Color Gamut & Color Temperaturereddish.png",
	"./Color Gamut & Color Temperaturesel_Low Blue Light.png": "./src/assets/img/Color Gamut & Color Temperaturesel_Low Blue Light.png",
	"./Color Gamut & Color Temperaturesel_bluish(9300k).png": "./src/assets/img/Color Gamut & Color Temperaturesel_bluish(9300k).png",
	"./Color Gamut & Color Temperaturesel_bt.709.png": "./src/assets/img/Color Gamut & Color Temperaturesel_bt.709.png",
	"./Color Gamut & Color Temperaturesel_custom 1.png": "./src/assets/img/Color Gamut & Color Temperaturesel_custom 1.png",
	"./Color Gamut & Color Temperaturesel_custom1.png": "./src/assets/img/Color Gamut & Color Temperaturesel_custom1.png",
	"./Color Gamut & Color Temperaturesel_dci-p3.png": "./src/assets/img/Color Gamut & Color Temperaturesel_dci-p3.png",
	"./Color Gamut & Color Temperaturesel_neutral.png": "./src/assets/img/Color Gamut & Color Temperaturesel_neutral.png",
	"./Color Gamut & Color Temperaturesel_reddish.png": "./src/assets/img/Color Gamut & Color Temperaturesel_reddish.png",
	"./Color Gamut & Color Temperaturesel_srgb.png": "./src/assets/img/Color Gamut & Color Temperaturesel_srgb.png",
	"./Color Gamut & Color Temperaturesrgb.png": "./src/assets/img/Color Gamut & Color Temperaturesrgb.png",
	"./Game Modeact.png": "./src/assets/img/Game Modeact.png",
	"./Game Modefps1.png": "./src/assets/img/Game Modefps1.png",
	"./Game Modefps2.png": "./src/assets/img/Game Modefps2.png",
	"./Game Modegame1.png": "./src/assets/img/Game Modegame1.png",
	"./Game Modegame2.png": "./src/assets/img/Game Modegame2.png",
	"./Game Modemoba.png": "./src/assets/img/Game Modemoba.png",
	"./Game Modeoff.png": "./src/assets/img/Game Modeoff.png",
	"./Game Modercg.png": "./src/assets/img/Game Modercg.png",
	"./Game Moderpg.png": "./src/assets/img/Game Moderpg.png",
	"./Game Moderts.png": "./src/assets/img/Game Moderts.png",
	"./Game Modesel_act.png": "./src/assets/img/Game Modesel_act.png",
	"./Game Modesel_fps1.png": "./src/assets/img/Game Modesel_fps1.png",
	"./Game Modesel_fps2.png": "./src/assets/img/Game Modesel_fps2.png",
	"./Game Modesel_game1.png": "./src/assets/img/Game Modesel_game1.png",
	"./Game Modesel_game2.png": "./src/assets/img/Game Modesel_game2.png",
	"./Game Modesel_moba.png": "./src/assets/img/Game Modesel_moba.png",
	"./Game Modesel_off.png": "./src/assets/img/Game Modesel_off.png",
	"./Game Modesel_rcg.png": "./src/assets/img/Game Modesel_rcg.png",
	"./Game Modesel_rpg.png": "./src/assets/img/Game Modesel_rpg.png",
	"./Game Modesel_rts.png": "./src/assets/img/Game Modesel_rts.png",
	"./Lan Indicatorcommunication.png": "./src/assets/img/Lan Indicatorcommunication.png",
	"./Lan Indicatornotconnected.png": "./src/assets/img/Lan Indicatornotconnected.png",
	"./Lan Indicatorsel_communication.png": "./src/assets/img/Lan Indicatorsel_communication.png",
	"./Lan Indicatorsel_notconnected.png": "./src/assets/img/Lan Indicatorsel_notconnected.png",
	"./Lan Indicatorsel_notconnected2.png": "./src/assets/img/Lan Indicatorsel_notconnected2.png",
	"./Scenario ModeDigital cinema.png": "./src/assets/img/Scenario ModeDigital cinema.png",
	"./Scenario ModePanel native.png": "./src/assets/img/Scenario ModePanel native.png",
	"./Scenario Modedigitalcinema.png": "./src/assets/img/Scenario Modedigitalcinema.png",
	"./Scenario Modeebook.png": "./src/assets/img/Scenario Modeebook.png",
	"./Scenario Modegaming.png": "./src/assets/img/Scenario Modegaming.png",
	"./Scenario Modeimage creation.png": "./src/assets/img/Scenario Modeimage creation.png",
	"./Scenario Modeimagecreation.png": "./src/assets/img/Scenario Modeimagecreation.png",
	"./Scenario Modelowbluelight.png": "./src/assets/img/Scenario Modelowbluelight.png",
	"./Scenario Modepanelnative.png": "./src/assets/img/Scenario Modepanelnative.png",
	"./Scenario Modeprofessionalimage.png": "./src/assets/img/Scenario Modeprofessionalimage.png",
	"./Scenario Modesel_Panel native.png": "./src/assets/img/Scenario Modesel_Panel native.png",
	"./Scenario Modesel_digital cinema.png": "./src/assets/img/Scenario Modesel_digital cinema.png",
	"./Scenario Modesel_digitalcinema.png": "./src/assets/img/Scenario Modesel_digitalcinema.png",
	"./Scenario Modesel_ebook.png": "./src/assets/img/Scenario Modesel_ebook.png",
	"./Scenario Modesel_gaming.png": "./src/assets/img/Scenario Modesel_gaming.png",
	"./Scenario Modesel_image creation.png": "./src/assets/img/Scenario Modesel_image creation.png",
	"./Scenario Modesel_imagecreation.png": "./src/assets/img/Scenario Modesel_imagecreation.png",
	"./Scenario Modesel_lowbluelight.png": "./src/assets/img/Scenario Modesel_lowbluelight.png",
	"./Scenario Modesel_panelnative.png": "./src/assets/img/Scenario Modesel_panelnative.png",
	"./Scenario Modesel_professionalimage.png": "./src/assets/img/Scenario Modesel_professionalimage.png",
	"./Scenario Modesel_video creation.png": "./src/assets/img/Scenario Modesel_video creation.png",
	"./Scenario Modesel_videocreation.png": "./src/assets/img/Scenario Modesel_videocreation.png",
	"./Scenario Modesel_webbrowsing.png": "./src/assets/img/Scenario Modesel_webbrowsing.png",
	"./Scenario Modesel_webbrowsing.png.png": "./src/assets/img/Scenario Modesel_webbrowsing.png.png",
	"./Scenario Modevideocreation.png": "./src/assets/img/Scenario Modevideocreation.png",
	"./Scenario Modewebbrowsing.png": "./src/assets/img/Scenario Modewebbrowsing.png",
	"./Video SignalDP 1.png": "./src/assets/img/Video SignalDP 1.png",
	"./Video SignalHDMI 1.png": "./src/assets/img/Video SignalHDMI 1.png",
	"./Video SignalHDMI 2.png": "./src/assets/img/Video SignalHDMI 2.png",
	"./Video Signaldp1.png": "./src/assets/img/Video Signaldp1.png",
	"./Video Signaldp2.png": "./src/assets/img/Video Signaldp2.png",
	"./Video Signaldp3.png": "./src/assets/img/Video Signaldp3.png",
	"./Video Signalhdmi1.png": "./src/assets/img/Video Signalhdmi1.png",
	"./Video Signalhdmi2.png": "./src/assets/img/Video Signalhdmi2.png",
	"./Video Signalsel_DP 1.png": "./src/assets/img/Video Signalsel_DP 1.png",
	"./Video Signalsel_HDMI 1.png": "./src/assets/img/Video Signalsel_HDMI 1.png",
	"./Video Signalsel_HDMI 2.png": "./src/assets/img/Video Signalsel_HDMI 2.png",
	"./Video Signalsel_dp1.png": "./src/assets/img/Video Signalsel_dp1.png",
	"./Video Signalsel_dp2.png": "./src/assets/img/Video Signalsel_dp2.png",
	"./Video Signalsel_dp3.png": "./src/assets/img/Video Signalsel_dp3.png",
	"./Video Signalsel_hdmi1.png": "./src/assets/img/Video Signalsel_hdmi1.png",
	"./Video Signalsel_hdmi2.png": "./src/assets/img/Video Signalsel_hdmi2.png",
	"./Video Signalsel_usb-c1.png": "./src/assets/img/Video Signalsel_usb-c1.png",
	"./Video Signalsel_usb-c2.png": "./src/assets/img/Video Signalsel_usb-c2.png",
	"./Video Signalsel_vga1.png": "./src/assets/img/Video Signalsel_vga1.png",
	"./Video Signalsel_vga2.png": "./src/assets/img/Video Signalsel_vga2.png",
	"./Video Signalusb-c1.png": "./src/assets/img/Video Signalusb-c1.png",
	"./Video Signalusb-c2.png": "./src/assets/img/Video Signalusb-c2.png",
	"./Video Signalvga1.png": "./src/assets/img/Video Signalvga1.png",
	"./Video Signalvga2.png": "./src/assets/img/Video Signalvga2.png",
	"./datepicker.png": "./src/assets/img/datepicker.png",
	"./down.png": "./src/assets/img/down.png",
	"./downSel.png": "./src/assets/img/downSel.png",
	"./logo.png": "./src/assets/img/logo.png",
	"./logout.png": "./src/assets/img/logout.png",
	"./refresh.png": "./src/assets/img/refresh.png",
	"./right.png": "./src/assets/img/right.png",
	"./searchIcon.png": "./src/assets/img/searchIcon.png",
	"./selUpload.png": "./src/assets/img/selUpload.png",
	"./time.png": "./src/assets/img/time.png",
	"./upload.png": "./src/assets/img/upload.png",
	"./userExample.png": "./src/assets/img/userExample.png",
	"./userExampleBAK.png": "./src/assets/img/userExampleBAK.png",
	"./video creation.png": "./src/assets/img/video creation.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*\\.png$";